const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 8,
    width: '100%',
    marginLeft: 24,
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid #E2E2FC',
    borderRadius: 8,
    marginTop: 18,
  },
  container: {
    backgroundColor: 'white',
    position: 'relative',
    zIndex: 1,
    width: '100%',
  },
  iconButton: {
    width: 40,
    height: 40,
    position: 'absolute',
    right: 15,
    zIndex: 2,
  },
  input: {
    width: '100%',
    paddingLeft: 12,
    height: 24,
    fontSize: '14px',
    borderRadius: 8,
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
    maxHeight: '70vh',
    overflow: 'scroll',
    width: 420,
  },
  suggestion: {
    display: 'block',
    fontSize: '14px',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  suggestionsContainer: {
    overflowY: 'scroll',
    width: '100%',
    height: '100%',
    maxHeight: '30vh',
    marginTop: 14,
    marginBottom: 50,
  },
  userRow: {
    height: 34,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #E2E2FC',
    fontFamily: "'Proxima Nova', sans-serif",
    marginTop: 2,
    borderRadius: 4,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: 16,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  userRowActive: {
    backgroundColor: '#E2E2FC',
  },

  chipsContainer: {
    width: '100%',
    display: 'flex',
    flex: 1,
    heigth: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 14,
  },

  chip: {
    marginLeft: 14,
    borderRadius: 4,
    border: `1px solid #E2E2FC`,
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    color: '#011533',
    backgroundColor: '#E2E2FC',
    marginBottom: 4,
  },
  closeIcon: {
    marginLeft: 10,
    padding: 4,
  },
  icon: {
    marginTop: 10,
    marginLeft: 10,
  },
})
export default styles
